<template>
    <div>
    <div class="robotMessage-title">{{msg.eventType === 'close' ? 'ОРДЕР ЗАКРЫТ' : 'ОРДЕР ОТКРЫТ'}} {{msg.symbol}}<br v-if="vers === 'widget'"> {{msg.id}} {{$datef(msg.timeEnter)}}</div>
        <div class="robotMessage-dataWrap">
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">ТИП И ОБЪЁМ</div>
                <div class="robotMessage-dataItem_data">
                    <span :class="msg.side === -1 ? 'color-red' : 'color-green'">{{msg.side === -1 ? 'SELL' : 'BUY'}}</span> {{msg.volume}}
                </div>
            </div>
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">ЦЕНА ОТКР.</div>
                <div class="robotMessage-dataItem_data">
                    {{msg.priceEnter}}
                </div>
            </div>
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">S/L</div>
                <div class="robotMessage-dataItem_data">
                    {{msg.sl}}
                </div>
            </div>
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">T/P</div>
                <div class="robotMessage-dataItem_data">
                    {{msg.tp}}
                </div>
            </div>
        </div>
        <div v-if="msg.eventType === 'close'" class="robotMessage-dataWrap">
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">ВРЕМЯ ОТКРЫТИЯ</div>
                <div class="robotMessage-dataItem_data">
                    {{$datef(msg.timeEnter)}}
                </div>
            </div>
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">ВРЕМЯ ЗАКРЫТИЯ</div>
                <div class="robotMessage-dataItem_data">
                    {{$datef(msg.timeExit)}}
                </div>
            </div>
            <div class="robotMessage-dataItem">
                <div class="robotMessage-dataItem_title">РЕЗУЛЬТАТ</div>
                <div class="robotMessage-dataItem_data">
                    <span :class="msg.resultDepo < 0 ? 'color-red' : 'color-green'">$ {{msg.resultDepo}}</span> <span :class="msg.resultPoint < 0 ? 'color-red' : 'color-green'">({{msg.resultPoint}} pip)</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['msg','vers']
}
</script>
<style lang="less" scoped>
.robotMessage {
    &-title {
        line-height: 1.54;
    }
    &-dataWrap {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 8px;
        &:last-child {
            margin-bottom: 0px;
        }
    }
    &-dataItem {
        margin-right: 23px;
        min-width: 100px;
    }
    &-dataItem {
        &_title {
            font-size:10px;
            color:#adc7e1;
            line-height: 2;
        }
    }
}
</style>